import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const createAgentChat = createAsyncThunk(
  "chat/createAgentChat",
  async (createData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post("/api/user/chat/agent/create", createData);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to create chat.");
    }
  }
);

const createChatAgentSlice = createSlice({
  name: "createChatAgent",
  initialState: {
    chatid: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createAgentChat.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.chatid = null;
      })
      .addCase(createAgentChat.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.chatid = action.payload;
      })
      .addCase(createAgentChat.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.chatid = null; 
      });
  },
});

export default createChatAgentSlice.reducer;